// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3SmwaUMRjs2Z7k {\n  box-sizing: content-box;\n  display: flex;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  background-color: #F4F5F7;\n  background-clip: padding-box;\n  background-origin: padding-box;\n  border-radius: 3px;\n  opacity: 0.8;\n  padding: 4px;\n  position: absolute;\n  right: 2px;\n  top: 2px;\n  visibility: hidden;\n  z-index: 40;\n}\n._3SmwaUMRjs2Z7k:hover {\n  background-color: #EBECF0;\n  opacity: 1;\n}\n._3SmwaUMRjs2Z7k:active {\n  background-color: #DFE1E6;\n  opacity: 1;\n}\n._3SmwaUMRjs2Z7k._3m44CEhOPerS7L {\n  visibility: visible;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCardButton": "_3SmwaUMRjs2Z7k",
	"show": "_3m44CEhOPerS7L"
};
export default ___CSS_LOADER_EXPORT___;
